import React from 'react';
import Investor from '../../models/Investor';

export interface InvestorContextType {
  investors: Investor[] | null;
  refreshInvestor: (id: string) => void;
  refreshUnreadCount: () => void; // New method to trigger unread count refresh
  eligibleInvestors: () => Investor[] | null;
  eligibleInvestorsCount: () => number;
  loading: () => boolean;
  unreadUpdatesCount: () => number;
}

const InvestorContext = React.createContext<InvestorContextType>({
  investors: null,
  refreshInvestor: () => {},
  refreshUnreadCount: () => {},
  eligibleInvestors: () => null,
  eligibleInvestorsCount: () => 0,
  loading: () => false,
  unreadUpdatesCount: () => 0,
});

export default InvestorContext;
